import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useGeneralProductionChartsDataContext } from './hooks/useGeneralProductionChartsDataContext';

export const AnnualEvolutionServices = () => {
    const { chartData } = useGeneralProductionChartsDataContext();


    return (
        <SimpleBars
            title={'Evolução Anual do Total de Atendimentos no Município'}
            horizontal={false}
            subtitles={chartData?.annualEvolutionServices?.map((item) => item.description)}
            values={chartData?.annualEvolutionServices?.map((item) => item.total  ||  0)}
        />
    );
};
